import { render, staticRenderFns } from "./VeiculosCategoria.vue?vue&type=template&id=5d5ee1f8&"
import script from "./VeiculosCategoria.js?vue&type=script&lang=js&"
export * from "./VeiculosCategoria.js?vue&type=script&lang=js&"
import style0 from "./VeiculosCategoria.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports